<template>
  <el-dialog
    :title="title"
    :visible.sync="localVisible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="系统编码" prop="systemCode">
        <el-input v-model="formData.systemCode" placeholder="请输入消防系统编码" maxlength="20" :disabled="type === 'edit'"></el-input>
      </el-form-item>
      <el-form-item label="系统名称" prop="systemName">
        <el-input v-model="formData.systemName" placeholder="请输入消防系统名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="description">
        <el-input type="textarea" v-model="formData.description" :rows="3" placeholder="请输入系统说明" maxlength="200"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deviceTypeService } from './deviceType.service';

export default {
  name: 'SystemDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add' // add or edit
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localVisible: false,
      formData: {
        uuid: '',
        systemCode: '',
        systemName: '',
        description: ''
      },
      rules: {
        systemCode: [{ required: true, message: '请输入系统编码', trigger: 'blur' }],
        systemName: [{ required: true, message: '请输入系统名称', trigger: 'blur' }]
      },
      submitting: false
    };
  },
  computed: {
    title() {
      return this.type === 'add' ? '新增消防系统' : '编辑消防系统';
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      if (this.type === 'edit' && this.initialData) {
        this.formData = {
          uuid: this.initialData.uuid,
          systemCode: this.initialData.systemCode,
          systemName: this.initialData.systemName,
          description: this.initialData.description
        };
      } else {
        this.formData = {
          uuid: '',
          systemCode: '',
          systemName: '',
          description: ''
        };
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
      this.$refs.form && this.$refs.form.resetFields();
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const submitData = { ...this.formData, status: 1 };

        deviceTypeService.saveFireSystem(submitData).then(() => {
          this.$message.success('保存成功');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__error {
  position: relative;
  top: 0;
  padding-top: 2px;
}
</style>
